module.exports = {"510683001":"剑南街道","510683002":"紫岩街道","510683104":"九龙镇","510683106":"汉旺镇","510683109":"麓棠镇","510683110":"广济镇","510683112":"玉泉镇","510683115":"新市镇","510683116":"孝德镇","510683119":"富新镇","510683122":"什地镇","510683124":"清平镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510683.json
// module id = 2429
// module chunks = 0